<script>
export default {
  beforeMount() {
    this.$on('AppRouteMixin.user.fetched', async () => {
      const promises = [
        this.$store.dispatch('cart/FETCH_AVAILABLE_GIFTS'),
        this.$store.dispatch('cart/FETCH_PAYMENTS'),
        this.$store.dispatch('cart/FETCH_SHIPPERS', { force: true }),
      ]
      await Promise.all(promises)
      this.$store.dispatch('cart/CHECK_SELECTED_GIFTS')
      this.$store.dispatch('cart/CHECK_SELECTED_PAYMENT')
      this.$store.dispatch('cart/CHECK_SELECTED_SHIPPER')
    })
  },
}
</script>
